﻿export const TemplateTypes = {
  CUSTOM: "Custom",
  GLOBAL: "Global",
};